import { createSelector } from '@ngrx/store';

import { AppState } from 'src/app/store';

import { Feature } from '../../enums/feature.enum';
import { FeatureFlag } from '../../models/feature-flag.model';

export const selectFeatureFlagsState = (state: AppState) => state.featureFlags;

export const selectFeatureFlags = createSelector(
    selectFeatureFlagsState,
    (state): FeatureFlag[] => state.featureFlags,
);

export const selectFeatureFlagsLoading = createSelector(
    selectFeatureFlagsState,
    (state): boolean => state.isLoading,
);

export const selectIsFeatureEnabled = (feature: Feature) =>
    createSelector(selectFeatureFlags, (featureFlags) =>
        featureFlags.some((flag) => flag.featureFlag === feature && flag.isEnabled),
    );
